import { render, staticRenderFns } from "./ProgArticle.vue?vue&type=template&id=73bcba9c"
import script from "./ProgArticle.vue?vue&type=script&lang=js"
export * from "./ProgArticle.vue?vue&type=script&lang=js"
import style0 from "./ProgArticle.vue?vue&type=style&index=0&id=73bcba9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports